<template>
  <div
    v-if="widget"
    class="hbt"
  >
    <div class="hbt-sec-head">
      <span class="hbt-h2">{{ widget.param.title || 'По привычкам' }}</span>
      <span class="hbt-kicker">{{ widget.param.subtitle || `${days} days` }}</span>
    </div>
    <div
      class="hbt-stats-row hbt-table-head"
      style="padding: 10px 0;"
    >
      <div>Привычка</div><div>Выполнено</div><div>Средне в день</div><div>Пропусков</div><div>Тренд</div>
    </div>
    <div
      v-for="row in rows"
      :key="row.id"
      class="hbt-stats-row"
      style="padding: 12px 0; border-bottom: 1px solid rgba(32,30,29,0.4); font-size: 14px; align-items: center;"
    >
      <div style="font-weight: 600;">
        {{ row.name }}
      </div>
      <div style="font-weight: 800;">
        {{ row.pct }}%
      </div>
      <div>{{ row.avg }}</div>
      <div>{{ row.miss }}</div>
      <span
        class="hbt-tag"
        :style="row.trendStyle"
        style="justify-self: start;"
      >{{ row.trend }}</span>
    </div>
  </div>
</template>

<script>
import {
  HBT_REFRESH, HBT_ZONES, hbtLoadHabits, hbtLoadLogs, hbtDayKey,
} from '@/cubus/components/dashboard/habits/habitsCore'

export default {
  name: 'CbsWidgetHabitStats',
  props: {
    widget: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      habits: [],
      logs: [],
    }
  },
  computed: {
    days() {
      return Number(this.widget.param.days) || 30
    },
    dayKeys() {
      const keys = []
      const d = new Date()
      d.setDate(d.getDate() - (this.days - 1))
      for (let i = 0; i < this.days; i += 1) {
        keys.push(hbtDayKey(d))
        d.setDate(d.getDate() + 1)
      }
      return keys
    },
    rows() {
      return this.habits
        .filter(h => h.type !== 'measure')
        .map(h => {
          const daily = this.dayKeys.map(k => this.logs
            .filter(l => l.habitId === h.id && l.day === k)
            .reduce((a, l) => a + l.reps, 0))
          const dayPct = daily.map(total => {
            if (h.type === 'check') return total > 0 ? 100 : 0
            if (h.plan > 0) return Math.min(100, Math.round((total / h.plan) * 100))
            return total > 0 ? 100 : 0
          })
          const pct = Math.round(dayPct.reduce((a, b) => a + b, 0) / (dayPct.length || 1))
          const activeDays = daily.filter(t => t > 0)
          const avg = h.type === 'check' || !activeDays.length
            ? '—'
            : `${Math.round(activeDays.reduce((a, b) => a + b, 0) / activeDays.length)} ${h.unit}`
          const miss = daily.filter(t => t === 0).length
          const half = Math.floor(dayPct.length / 2)
          const older = dayPct.slice(0, half)
          const recent = dayPct.slice(half)
          const mean = arr => (arr.length ? arr.reduce((a, b) => a + b, 0) / arr.length : 0)
          const diff = mean(recent) - mean(older)
          let trend = 'Стабильно'
          let zone = HBT_ZONES.ok
          if (diff > 5) trend = 'Стало лучше'
          else if (diff < -5) {
            trend = 'Стало хуже'
            zone = HBT_ZONES.warn
          }
          return {
            id: h.id,
            name: h.name,
            pct,
            avg,
            miss,
            trend,
            trendStyle: { background: zone.bg, color: zone.color, borderColor: zone.border },
          }
        })
    },
  },
  created() {
    this.load()
    this.$root.$on(HBT_REFRESH, this.reload)
  },
  beforeDestroy() {
    this.$root.$off(HBT_REFRESH, this.reload)
  },
  methods: {
    async load() {
      this.habits = await hbtLoadHabits(this, this.widget.param)
      await this.reload()
    },
    async reload() {
      this.logs = await hbtLoadLogs(this, this.widget.param, this.days)
    },
  },
}
</script>

<style src="./habits/habits.css"></style>
<style scoped>
.hbt-stats-row {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1fr auto;
  gap: 12px;
}
</style>
